import { Link } from "gatsby"
import PropTypes, { element } from "prop-types"
import React from "react"
import * as cfg from "../cfg"

const HeaderElement = (props) => (
  <h4 style={{ flexGrow: props.size }}>
    {props.url !== undefined ? (
      <a href={props.url} className="header-item">
        {props.elementName}
      </a>
    ) : (
      <Link to={props.link} className="header-item">
        {props.elementName}
      </Link>
    )}
  </h4>
)

const Header = () => (
  <header>
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `0 1em 1em 1em`,
        display: `flex`,
        flexDirection: `row`,
      }}
    >
      {/* <HeaderElement elementName="Noah Trenaman" size={2} link="/" /> */}
      {/* <HeaderElement elementName='posts' size={1} url='/posts'/> */}
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
